import component from './family-plan-member-info.component';
import routes from './family-plan-member-info.routes';
import familyPlanUserInfoComponent from './../family-plan-info/family-plan-info.component';
import manageSubDeleteDialogComponent from './../manage-sub-delete-dialog/manage-sub-delete-dialog.component';
import masterAddressUpdateDialogComponent from './../master-address-update-dialog/master-address-update-dialog.component';

export default angular
  .module('fizyweb.paycell.familyPlanMemberInfo', [])
  .component('fizyPaycellFamilyPlanMemberInfo', component)
  .component('familyPlanUserInfo', familyPlanUserInfoComponent)
  .component('manageSubDeleteDialog', manageSubDeleteDialogComponent)
  .component('masterAddressUpdateDialog', masterAddressUpdateDialogComponent) 
  .config(routes).name;


  



// WEBPACK FOOTER //
// src/app/family-plan/family-plan-member-info/family-plan-member-info.module.ts